import React from 'react';
import { observer } from 'mobx-react';

import { InjectedStyledComponent } from '../../../../../shared/index.js';
import { ITableEvents } from '../../models/index.js';
import HeadRow from '../HeadRow/HeadRow.js';
import { TableComponentBase } from '../TableComponentBase.js';

import { IHeadConfiguration, IHeadProps, IHeadState } from './models/index.js';
import { HEAD_CATEGORY_KEY, HEAD_COMPONENT_KEY, HEAD_PARENT_COMPONENT_KEY } from './Head.meta.js';

export class Head extends TableComponentBase<
	IHeadProps & React.TableHTMLAttributes<HTMLTableSectionElement>,
	IHeadState,
	IHeadConfiguration
> {
	categoryKey = HEAD_CATEGORY_KEY;
	componentKey = HEAD_COMPONENT_KEY;
	get parentComponentKey(): string | undefined {
		return HEAD_PARENT_COMPONENT_KEY;
	}
	get tableEventsKey(): keyof ITableEvents {
		return 'head';
	}
	constructor(props: IHeadProps) {
		super(props);
	}
	render() {
		const {
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			children,
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			configuration,
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			componentStyle,
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			componentStyleProps,
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			table,

			headerRows = [],
			...otherProps
		} = this.props;
		const events = this.getEvents(this.eventsForElement);
		return (
			<thead {...events} {...otherProps}>
				{headerRows.map((headerRow, headerRowIndex) => {
					return (
						<HeadRow
							key={this.getHeadRowKey(headerRowIndex)}
							table={this.table}
							headerRow={headerRow}
							rowIndex={headerRowIndex}
						/>
					);
				})}
			</thead>
		);
	}
}

export default InjectedStyledComponent(observer(Head), HEAD_CATEGORY_KEY, HEAD_PARENT_COMPONENT_KEY, [
	HEAD_COMPONENT_KEY,
]);
